export const ACCOUNTS_TITLE = 'ACCOUNTS';
export const ADMINISTRATION_ACCOUNTS_TITLE = 'ADMINISTRATION_ACCOUNTS';
export const ADMINISTRATION_ACCOUNT_GROUPS_TITLE = 'ADMINISTRATION_ACCOUNT_GROUPS';
export const ADMINISTRATION_USER_REPORTS_TITLE = 'ADMINISTRATION_USERREPORTS';
export const ADMINISTRATION_USERS_TITLE = 'ADMINISTRATION_USERS';
export const INTRADAY_ENTRIES_TITLE = 'INTRADAYENTRIES';
export const INTRADAYS_TITLE = 'INTRADAYS';
export const STATEMENT_TRANSACTIONS_TITLE = 'STATEMENT_TRANSACTIONS';
export const STATEMENTS_TITLE = 'STATEMENTS';
export const TRANSACTIONS_TITLE = 'TRANSACTIONS';
export const VALUESERIES_TITLE = 'VALUESERIES';
export const ERRONEOUS_STMTS_TITLE = 'ERRONEOUS_STATEMENTS';
export const NON_MOVEMENT_ACCOUNTS = 'NON_MOVEMENT_ACCOUNTS';
export const NON_REPORTING_ACCOUNTS = 'NON_REPORTING_ACCOUNTS';
export const DOWNLOADS_ARCHIVE = 'downloadsArchive';

// Correspondance between page title and csv file name prefix
export const CSV_FILE_PREFIX_MAP = {
    [[ACCOUNTS_TITLE]]: 'Account_List',
    [[INTRADAY_ENTRIES_TITLE]]: 'IntradayEntries_List',
    [[INTRADAYS_TITLE]]: 'Intraday_List',
    [[TRANSACTIONS_TITLE]]: 'Transaction_List',
    [[STATEMENT_TRANSACTIONS_TITLE]]: 'StatementEntries_List',
    [[STATEMENTS_TITLE]]: 'Statement_List',
    [[VALUESERIES_TITLE]]: 'ValueSeries_List',
    [[ERRONEOUS_STMTS_TITLE]]: 'ErroneousStatement_List',
    [[ADMINISTRATION_ACCOUNTS_TITLE]]: 'AccountAdministration_List',
    [[ADMINISTRATION_ACCOUNT_GROUPS_TITLE]]: 'AccountGroups_List',
    [[NON_MOVEMENT_ACCOUNTS]]: 'NonMovementAccount_List',
    [[NON_REPORTING_ACCOUNTS]]: 'NonReportingAccount_List',
    [[DOWNLOADS_ARCHIVE]]: 'DownloadsArchive',
    [[ADMINISTRATION_USER_REPORTS_TITLE]]: 'UserReports'
}
